/* eslint-disable import/prefer-default-export */
export const round = (value: number): number => Math.round(value * 10) / 10;
